export default __webpack_public_path__ + "static/media/alibaba.c559041d.svg";